// Routes del módulo invoicing. Cada tab del registry mapea a una vista:
//   /m/invoicing/dashboard → Dashboard MTD/AR
//   /m/invoicing/list      → Lista de facturas
//   /m/invoicing/create    → Crear factura draft

import { useState } from 'react';

import { InvoicingDashboard } from './components/Dashboard';
import { InvoiceForm } from './components/InvoiceForm';
import { InvoiceList } from './components/InvoiceList';

export function InvoicingDashboardView() {
  return (
    <div className="space-y-4 p-4">
      <h1 className="text-xl font-semibold">Facturación · Dashboard MTD / AR</h1>
      <InvoicingDashboard />
    </div>
  );
}

export function InvoicingListView() {
  return (
    <div className="space-y-4 p-4">
      <h1 className="text-xl font-semibold">Facturas</h1>
      <InvoiceList />
    </div>
  );
}

export function InvoicingCreateView() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [createdId, setCreatedId] = useState<string | null>(null);

  return (
    <div className="space-y-4 p-4">
      <h1 className="text-xl font-semibold">Nueva factura</h1>
      {createdId ? (
        <div className="border rounded p-4 space-y-2">
          <div className="text-sm text-emerald-600 dark:text-emerald-400">
            Factura creada en estado <strong>draft</strong>: <code>{createdId}</code>
          </div>
          <button
            onClick={() => {
              setCreatedId(null);
              setRefreshKey((k) => k + 1);
            }}
            className="text-sm underline"
          >
            Crear otra
          </button>
        </div>
      ) : (
        <InvoiceForm
          key={refreshKey}
          onCreated={(id) => setCreatedId(id)}
        />
      )}
    </div>
  );
}
